import { render, staticRenderFns } from "./InvoiceOrderDialog.vue?vue&type=template&id=5f1f2e8b"
import script from "./InvoiceOrderDialog.vue?vue&type=script&lang=js"
export * from "./InvoiceOrderDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports